import { AuthorPageComponent } from './AuthorPageComponent';
import { configReducer } from '../../store/config/config.reducer';
import { footerReducer } from '../../store/footer/footer.reducer';
import { primaryHeaderReducer } from '../../store/primaryHeader/primaryHeader.reducer';
import { secondaryHeaderReducer } from '../../store/secondaryHeader/secondaryHeader.reducer';
import { authorPageReducer } from '../../store/template/authorPage/authorPage.reducer';
import { TemplateRegistration } from '../templateRegistration';
import { injectButtonToFooterLinksSectionEvent, injectVideoLogoEvent } from '../../client/clientAPI/events';

const rootReducer = {
    config: configReducer,
    footer: footerReducer,
    primaryHeader: primaryHeaderReducer,
    secondaryHeader: secondaryHeaderReducer,
    template: authorPageReducer,
};


export const AuthorPage = new TemplateRegistration()
    .setComponent(AuthorPageComponent)
    .setRootReducer(rootReducer)
    .addClientAPIEvent(injectVideoLogoEvent)
    .addClientAPIEvent(injectButtonToFooterLinksSectionEvent)
    .build();
